import { useEffect } from "react";

/**
 * Lightweight SEO meta updater (sets <title>, meta description, OG/Twitter,
 * canonical, and optional JSON-LD structured data). No extra deps.
 */
export const SEO = ({
  title,
  description,
  image,
  url,
  type = "website",
  jsonLd,
}) => {
  useEffect(() => {
    if (title) document.title = title;

    const upsertMeta = (selector, attr, key, value) => {
      if (!value) return;
      let el = document.head.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", value);
    };

    upsertMeta('meta[name="description"]', "name", "description", description);
    upsertMeta('meta[property="og:title"]', "property", "og:title", title);
    upsertMeta('meta[property="og:description"]', "property", "og:description", description);
    upsertMeta('meta[property="og:image"]', "property", "og:image", image);
    upsertMeta('meta[property="og:url"]', "property", "og:url", url || window.location.href);
    upsertMeta('meta[property="og:type"]', "property", "og:type", type);
    upsertMeta('meta[property="og:site_name"]', "property", "og:site_name", "ZaykaQR");
    upsertMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    upsertMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    upsertMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    upsertMeta('meta[name="twitter:image"]', "name", "twitter:image", image);

    // canonical
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url || window.location.href);

    // JSON-LD
    let ld = document.head.querySelector('script[data-zq-jsonld="true"]');
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.setAttribute("type", "application/ld+json");
        ld.setAttribute("data-zq-jsonld", "true");
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, image, url, type, jsonLd]);

  return null;
};
